export default __webpack_public_path__ + "aecd24f.png";